
import React from 'react'
import Icon from './Icon'

const FaAngleDown = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m31 16.4q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.3-0.5 0.3t-0.6-0.3l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l1.2-1.1q0.2-0.2 0.5-0.2t0.5 0.2l8.8 8.8 8.7-8.8q0.3-0.2 0.5-0.2t0.6 0.2l1.1 1.1q0.2 0.2 0.2 0.5z"/></g>
    </Icon>
)

export default FaAngleDown



// WEBPACK FOOTER //
// ./src/components/Icon/angle-down.js